import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getInstallableModulesInfo } from '../../../selectors/layout';
import { Props } from './AddWidget';

type StateProps = Pick<Props, 'hasCoreMembership' | 'installableModulesInfo'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  props
) => ({
  hasCoreMembership: getCurrentUserHasCore(state),
  installableModulesInfo: props.installableModules.map(module => {
    const modulesInfo = getInstallableModulesInfo(
      state,
      props.section,
      module.zone
    );
    return {
      ...module,
      limit: 0,
      ...modulesInfo.find(
        moduleInfo => moduleInfo.moduleName === module.moduleName
      ),
    };
  }),
});

export default connect(mapStateToProps);
